const ProviderViews = require('./ProviderView')
const SearchProviderViews = require('./SearchProviderView')

module.exports = {
  ProviderViews,
  SearchProviderViews,
}
